// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"fc387765","760":"67a55ea9"}[chunkId] + ".chunk.css";
};